import React from 'react';

export default function NoContent(){
    return (
        <div className="no-content text-center">
            Bu sayfanın içeriği şu an hazırlanmaktadır!
        </div>
    )
}